import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=388a1a68&scoped=true&lang=pug&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"
import style0 from "./logout.vue?vue&type=style&index=0&id=388a1a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a1a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388a1a68')) {
      api.createRecord('388a1a68', component.options)
    } else {
      api.reload('388a1a68', component.options)
    }
    module.hot.accept("./logout.vue?vue&type=template&id=388a1a68&scoped=true&lang=pug&", function () {
      api.rerender('388a1a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/logout/logout.vue"
export default component.exports